import { useRef, useState } from 'react';

// Kleines Fragezeichen, das bei Mauszeiger oder Tastaturfokus eine Erklärung zeigt.
//
// Bewusst ohne title-Attribut: Der Browser-Tooltip erscheint erst nach gut einer
// Sekunde, bricht lange Texte nicht um und ist per Tastatur gar nicht erreichbar.
//
// Die Blase wird beim Anzeigen vermessen und fest im Fenster positioniert, statt
// relativ zum Symbol. Grund: Mehrere Bereiche der Oberfläche (Detailspalten,
// Dialoge) setzen overflow – eine absolut positionierte Blase würde dort an der
// Kante abgeschnitten.
const BUBBLE_WIDTH = 290;
const RAND = 8;

export default function Info({ text, align = 'left' }) {
  const ref = useRef(null);
  const [pos, setPos] = useState(null);

  const show = () => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();

    // Rechtsbündig, wenn das Symbol am rechten Rand sitzt – sonst würde die Blase
    // aus dem Fenster laufen.
    let left = align === 'right' ? r.right - BUBBLE_WIDTH : r.left - 6;
    left = Math.max(RAND, Math.min(left, window.innerWidth - BUBBLE_WIDTH - RAND));

    setPos({ top: r.bottom + 8, left });
  };

  const hide = () => setPos(null);

  return (
    <span
      ref={ref}
      className="info"
      tabIndex={0}
      role="note"
      aria-label={text}
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
    >
      <svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true">
        <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" />
        <path
          d="M12 16v-5M12 8h.01"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>

      {pos && (
        <span
          className="info-bubble"
          style={{ top: pos.top, left: pos.left, width: BUBBLE_WIDTH }}
        >
          {text}
        </span>
      )}
    </span>
  );
}
